import {about_tr, about_en} from '../assets/Context/about_context'
import {navbar_tr, navbar_en} from '../assets/Context/navbar_context'
import {ind_ser_tr, ind_ser_en} from '../assets/Context/industrial_context'
import {mrn_ser_tr, mrn_ser_en} from '../assets/Context/marine_context'
import {laser_tr, laser_en} from '../assets/Context/laser_context'
import {contact_tr, contact_en} from '../assets/Context/contact_context'
import {mach_tr, mach_en} from '../assets/Context/mach_context'


// -------------------------  NavBar Section -------------------------
export function buildNavbarContext(lang = "TR") {
    return lang === "EN" ? navbar_en : navbar_tr;
}

//Navbar Items Structure
export function buildNavItems(lang = "TR") {
    const navbarContext = buildNavbarContext(lang)
    return [
        { type: "link", href: "#about", label: navbarContext.about },

        {
        type: "dropdown",
        id: "#marine-services",
        title: navbarContext.marine_services,
        items: [
            { href: "#marine-services", label: navbarContext.services_overview },
            { href: "#marine-services", label: navbarContext.ship_deck_equipment },
            { href: "#marine_pipe", label: navbarContext.ship_machinery_equipment },
            { href: "#marine_shell", label: navbarContext.ship_piping_hydraulic_systems },
            { href: "#marine-services", label: navbarContext.condenser_heat_exchangers },
            { href: "#marine-services", label: navbarContext.ship_steel_construction },
        ],
        },
        
        {
        type: "dropdown",
        id: "#industrial-services",
        title: navbarContext.industrial_services,
        items: [
            { href: "#industrial-services", label: navbarContext.services_overview },
            { href: "#industrial-services", label: navbarContext.elec_panel },
            { href: "#industrial-services", label: navbarContext.stainless_steel_boiler },
            { href: "#industrial-services", label: navbarContext.steel_construction },
            { href: "#industrial-services", label: navbarContext.storage_tanks },
            { href: "#industrial-services", label: navbarContext.carbon_coal_filters }
        ],
        },

        { type: "link", href: "#laser-cut", label: navbarContext.laserCut },
        { type: "link", href: "#machining", label: navbarContext.machining },
        { type: "link", href: "#contact", label: navbarContext.contact },
    ];
}


// -------------------------  About Section -------------------------
export function buildAboutContext(lang = "TR") {
      return lang === "EN" ? about_en : about_tr;
}

export function buildAboutItems(lang = "TR") {
    const aboutContext = buildAboutContext(lang)
    return [
      {
        title: aboutContext.p_1_title,
        text: aboutContext.p_1
      },
     {
        title: aboutContext.p_2_title,
        text: aboutContext.p_2
      },
      {
        title: aboutContext.p_3_title,
        text: aboutContext.p_3
      }
    ];
}






// -------------------------  Industrial Services -------------------------
export function buildIndustrialContext(lang = "TR") {
      return lang === "EN" ? ind_ser_en : ind_ser_tr;
}


export function buildIndustrialItems(lang = "TR") {
  const industrialContext = buildIndustrialContext(lang);
  const isEN = lang === "EN";

  return [
    {
      photoURL: [
        "/assets/Industrial/boiler1.png",
        "/assets/Industrial/boiler2.png",
        "/assets/Industrial/boiler3.png",
      ],
      title: industrialContext.service_title_1,
      text: industrialContext.service_p_1,
      points: isEN
        ? [
            {
              before: "",
              bold: "High-pressure resistant",
              after: " stainless steel coil-type boilers are manufactured for industrial use.",
            },
            {
              before: "Heating capacity, coil design, material selection, and dimensions are calculated ",
              bold: "specifically for each project",
              after: ".",
            },
            {
              before: "",
              bold: "Long service life, low maintenance, and CE compliance",
              after: " are among our key production criteria.",
            },
          ]
        : [
            {
              before: "",
              bold: "Yüksek basınca dayanıklı",
              after: " paslanmaz çelik serpantinli boyler imalatı yapılmaktadır.",
            },
            {
              before: "Isıtma kapasitesi, serpantin yapısı, malzeme seçimi ve kazan ölçüleri gibi ",
              bold: "mühendislik hesaplamaları",
              after: " projeye özel olarak yapılmaktadır.",
            },
            {
              before: "",
              bold: "Uzun ömürlü yapı, düşük bakım ihtiyacı ve CE standartlarına uygunluk",
              after: " üretim kriterlerimiz arasında yer almaktadır.",
            },
          ],
      btn: industrialContext.button_title,
    },

    {
      photoURL: ["/assets/Industrial/pipe1.png"],
      title: industrialContext.service_title_2,
      text: industrialContext.service_p_2,
      points: isEN
        ? [
            {
              before: "",
              bold: "Cable trays, cable ladders, electrical cabinets, and panels",
              after: " are manufactured for ship electrical companies and industrial projects.",
            },
            {
              before: "Systems are produced with ",
              bold: "project-specific dimensions and material options",
              after: ".",
            },
            {
              before: "They are designed to ensure ",
              bold: "safe, organized, and long-lasting cable routing",
              after: ".",
            },
            {
              before: "",
              bold: "Durability, ease of installation, and suitability",
              after: " are key criteria throughout production.",
            },
          ]
        : [
            {
              before: "",
              bold: "Kablo yolları, kablo traversleri, metal elektrik panoları ve paneller",
              after: " gemi elektrik firmaları ve endüstriyel projeler için imal edilmektedir.",
            },
            {
              before: "Sistemler, proje ihtiyaçlarına uygun ",
              bold: "ölçü ve malzeme seçenekleriyle",
              after: " üretilmektedir.",
            },
            {
              before: "Elektrik kablolarının ",
              bold: "güvenli, düzenli ve uzun ömürlü",
              after: " şekilde taşınması ve korunması hedeflenmektedir.",
            },
            {
              before: "",
              bold: "Dayanıklılık, montaj kolaylığı ve uygulama alanına uygunluk",
              after: " temel üretim kriterleri arasında yer almaktadır.",
            },
          ],
      btn: industrialContext.button_title,
    },

    {
      photoURL: ["/assets/Industrial/steel1.png"],
      title: industrialContext.service_title_3,
      text: industrialContext.service_p_3,
      points: isEN
        ? [
            {
              before: "We provide ",
              bold: "project-specific steel structure solutions",
              after: " with high production precision.",
            },
            {
              before: "",
              bold: "Industrial buildings, platforms, load-bearing systems, machinery frames, and work areas",
              after: " are manufactured according to project needs.",
            },
            {
              before: "Our solutions offer ",
              bold: "robust design, high load-bearing capacity, and long service life",
              after: ".",
            },
            {
              before: "From design to manufacturing, we deliver ",
              bold: "reliable and sustainable solutions",
              after: ".",
            },
          ]
        : [
            {
              before: "",
              bold: "Projeye özel çelik konstrüksiyon çözümleri",
              after: " yüksek üretim hassasiyetiyle sunulmaktadır.",
            },
            {
              before: "",
              bold: "Sanayi yapıları, platformlar, taşıyıcı sistemler, makine şaseleri ve çalışma alanları",
              after: " ihtiyaca göre imal edilmektedir.",
            },
            {
              before: "Çözümlerimiz; ",
              bold: "sağlam yapı, yüksek taşıma kapasitesi ve uzun kullanım ömrü",
              after: " ile farklı sektörlere hitap eder.",
            },
            {
              before: "Tasarımdan imalata kadar tüm aşamalarda ",
              bold: "güvenilir ve sürdürülebilir çözümler",
              after: " sunulmaktadır.",
            },
          ],
      btn: industrialContext.button_title,
    },

    {
      photoURL: ["/assets/Industrial/storagetank1.png"],
      title: industrialContext.service_title_4,
      text: industrialContext.service_p_4,
      points: isEN
        ? [
            {
              before: "Storage tanks are manufactured with ",
              bold: "high-quality materials, robust construction, and precise production",
              after: ".",
            },
            {
              before: "Different sizes, capacities, and technical specifications are produced according to ",
              bold: "usage purpose and project requirements",
              after: ".",
            },
            {
              before: "",
              bold: "Durability, leak-proof performance, and long service life",
              after: " are prioritized in every tank system.",
            },
            {
              before: "Our tanks are suitable for ",
              bold: "industrial facilities, chemical, food, water, energy, maritime, and agricultural applications",
              after: ".",
            },
          ]
        : [
            {
              before: "Depolama tankları; ",
              bold: "kaliteli malzeme, sağlam konstrüksiyon ve yüksek üretim hassasiyeti",
              after: " ile imal edilmektedir.",
            },
            {
              before: "Kullanım amacı ve proje gerekliliklerine göre ",
              bold: "farklı ölçü, kapasite ve teknik özelliklerde",
              after: " üretim yapılmaktadır.",
            },
            {
              before: "",
              bold: "Dayanıklılık, sızdırmazlık ve uzun ömürlü kullanım",
              after: " her tank sisteminde öncelikli kriterlerdir.",
            },
            {
              before: "Tanklarımız; ",
              bold: "endüstriyel tesisler, kimya, gıda, su sistemleri, enerji, denizcilik ve tarım uygulamaları",
              after: " için uygundur.",
            },
          ],
      btn: industrialContext.button_title,
    },

    {
      photoURL: ["/assets/Industrial/corbon1.png"],
      title: industrialContext.service_title_5,
      text: industrialContext.service_p_5,
      points: isEN
        ? [
            {
              before: "Carbon and coal brush holders require ",
              bold: "high-precision mechanical manufacturing",
              after: " due to the movement of the carbon inside its housing.",
            },
            {
              before: "Production focuses on ",
              bold: "surface friction tolerance, stable pressure force, and axis precision",
              after: ".",
            },
            {
              before: "This process ensures ",
              bold: "high current conductivity and maximum efficiency",
              after: ".",
            },
            {
              before: "Our solid block production method provides ",
              bold: "longer-lasting, stable, and arc-free operation",
              after: " compared to cast carbon holders.",
            },
          ]
        : [
            {
              before: "Karbon ve kömür fırça tutucular, karbonun yuva içinde hareketli çalışması nedeniyle ",
              bold: "yüksek hassasiyetli mekanik üretim",
              after: " gerektirir.",
            },
            {
              before: "Üretim sürecinde ",
              bold: "yüzeysel sürtünme toleransları, stabil baskı kuvveti ve eksen hassasiyeti",
              after: " ön planda tutulur.",
            },
            {
              before: "Bu sayede ",
              bold: "yüksek akım geçirgenliği ve maksimum verim",
              after: " elde edilir.",
            },
            {
              before: "Dolu blok malzemeden üretim yöntemiyle ",
              bold: "daha uzun ömürlü, stabil ve ark yapmadan çalışan",
              after: " fırça tutucular sunulmaktadır.",
            },
          ],
      btn: industrialContext.button_title,
    },
  ];
}


// -------------------------  Marine Services -------------------------
export function buildMarineContext(lang = "TR") {
      return lang === "EN" ? mrn_ser_en : mrn_ser_tr;
}


export function buildMarineItems(lang = "TR") {
  const marineContext = buildMarineContext(lang);
  const isEN = lang === "EN";

  return [
    {
      photoURL: ["/assets/Marine/deck.png"],
      title: marineContext.service_title_1,
      text: marineContext.service_p_1,
      points: isEN
        ? [
            {
              before: "",
              bold: "Cranes, winches, hatches, ladders, and railings",
              after: " are professionally manufactured, maintained, and repaired.",
            },
            {
              before: "",
              bold: "Marine-resistant material selection and reliable workmanship",
              after: " ensure long-lasting solutions.",
            },
            {
              before: "All operations are carried out in compliance with ",
              bold: "international maritime standards",
              after: ".",
            },
          ]
        : [
            {
              before: "",
              bold: "Vinç, ırgat, kapak, merdiven ve korkuluk sistemleri",
              after: " profesyonel şekilde imal edilmekte, bakım ve onarımları yapılmaktadır.",
            },
            {
              before: "",
              bold: "Deniz koşullarına dayanıklı malzeme seçimi ve güvenilir işçilik",
              after: " ile uzun ömürlü çözümler sağlanmaktadır.",
            },
            {
              before: "Tüm çalışmalar ",
              bold: "uluslararası denizcilik standartlarına uygun",
              after: " şekilde gerçekleştirilmektedir.",
            },
          ],
      btn: marineContext.button_title,
    },

    {
      photoURL: ["/assets/Marine/marmach1.png"],
      title: marineContext.service_title_2,
      text: marineContext.service_p_2,
      points: isEN
        ? [
            {
              before: "",
              bold: "Pumps, valves, heat exchangers, boilers, and engine room equipment",
              after: " are professionally maintained and repaired.",
            },
            {
              before: "",
              bold: "High engineering discipline and quality standards",
              after: " are applied throughout all processes.",
            },
            {
              before: "We provide ",
              bold: "fast and effective solutions",
              after: " compatible with port and shipyard operations.",
            },
          ]
        : [
            {
              before: "",
              bold: "Pompa, valf, eşanjör, boyler ve makine dairesi ekipmanları",
              after: " profesyonel şekilde bakım ve onarımdan geçirilmektedir.",
            },
            {
              before: "",
              bold: "Yüksek kalite standartları ve mühendislik disiplini",
              after: " tüm süreçlerde uygulanmaktadır.",
            },
            {
              before: "Liman ve tersane süreçlerine uygun ",
              bold: "hızlı ve etkin çözümler",
              after: " sunulmaktadır.",
            },
          ],
      btn: marineContext.button_title,
    },

    {
      photoURL: ["/assets/Marine/pipes1.png","/assets/Marine/pipes2.png"],
      title: marineContext.service_title_3,
      text: marineContext.service_p_3,
      points: isEN
        ? [
            {
              before: "",
              bold: "Manufacturing, maintenance, and repair services",
              after: " are provided for ship piping and hydraulic systems.",
            },
            {
              before: "Fuel, oil, water, steam, and fire lines are handled with ",
              bold: "precision installation and leak testing",
              after: ".",
            },
            {
              before: "",
              bold: "Pressure lines, valve groups, cylinders, and power units",
              after: " are serviced to maximize system performance.",
            },
            {
              before: "",
              bold: "Correct assembly, material selection, and precise workmanship",
              after: " ensure long-lasting and safe operation.",
            },
          ]
        : [
            {
              before: "",
              bold: "Gemi boru devreleri ve hidrolik sistemler için kapsamlı imalat, bakım ve onarım hizmetleri",
              after: " sunulmaktadır.",
            },
            {
              before: "Yakıt, yağ, su, buhar ve yangın hatlarında ",
              bold: "hassas montaj ve sızdırmazlık kontrolleri",
              after: " gerçekleştirilmektedir.",
            },
            {
              before: "",
              bold: "Basınçlı hatlar, valf grupları, silindirler ve güç üniteleri",
              after: " sistem performansını artıracak şekilde bakım görmektedir.",
            },
            {
              before: "",
              bold: "Doğru montaj, uygun malzeme seçimi ve hassas işçilik",
              after: " uzun ömürlü ve güvenli kullanım sağlamaktadır.",
            },
          ],
      btn: marineContext.button_title,
    },

    {
      photoURL: ["/assets/Marine/shell1.png", "/assets/Marine/shell2.png","/assets/Marine/shell3.png"],
      title: marineContext.service_title_4,
      text: marineContext.service_p_4,
      points: isEN
        ? [
            {
              before: "",
              bold: "Condensers and Shell & Tube heat exchangers",
              after: " are manufactured and repaired for industrial and marine applications.",
            },
            {
              before: "Systems are designed according to ",
              bold: "operating conditions and engineering requirements",
              after: ".",
            },
            {
              before: "",
              bold: "Tube bundle production, coil systems, flange connections, and engineering calculations",
              after: " are carried out meticulously.",
            },
          ]
        : [
            {
              before: "",
              bold: "Kondenser ve Shell & Tube ısı değiştiriciler",
              after: " endüstriyel ve denizcilik uygulamaları için imal edilmekte ve onarılmaktadır.",
            },
            {
              before: "Sistemler ",
              bold: "çalışma koşulları ve mühendislik gereksinimlerine uygun",
              after: " şekilde tasarlanmaktadır.",
            },
            {
              before: "",
              bold: "Boru demeti üretimi, serpantin sistemleri, flanş bağlantıları ve mühendislik hesaplamaları",
              after: " titizlikle gerçekleştirilmektedir.",
            },
          ],
      btn: marineContext.button_title,
    },

    {
      photoURL: ["/assets/Marine/steelkonst1.png","/assets/Marine/steelkonst2.png"],
      title: marineContext.service_title_5,
      text: marineContext.service_p_5,
      points: isEN
        ? [
            {
              before: "",
              bold: "Ship blocks, chassis structures, platforms, and custom constructions",
              after: " are manufactured for shipbuilding and maintenance industries.",
            },
            {
              before: "",
              bold: "High durability and long service life",
              after: " are targeted in every project.",
            },
            {
              before: "All manufacturing processes use ",
              bold: "marine-resistant materials and internationally compliant welding techniques",
              after: ".",
            },
            {
              before: "",
              bold: "Project-specific engineering solutions",
              after: " are provided from design to assembly.",
            },
          ]
        : [
            {
              before: "",
              bold: "Gemi blokları, şase yapıları, platformlar ve özel konstrüksiyon çözümleri",
              after: " gemi inşa ve bakım sektörüne yönelik üretilmektedir.",
            },
            {
              before: "",
              bold: "Maksimum dayanıklılık ve uzun ömür",
              after: " her projede temel hedef olarak ele alınmaktadır.",
            },
            {
              before: "Tüm üretim süreçlerinde ",
              bold: "deniz şartlarına uygun malzeme ve uluslararası standartlara uygun kaynak teknikleri",
              after: " kullanılmaktadır.",
            },
            {
              before: "",
              bold: "Projeye özel mühendislik çözümleri",
              after: " tasarımdan montaja kadar sunulmaktadır.",
            },
          ],
      btn: marineContext.button_title,
    },
  ];
}






// -------------------------  Laser Cut -------------------------

export function buildLaserContext(lang = "TR") {
      return lang === "EN" ? laser_en : laser_tr;
}



// -------------------------  Machining  -------------------------

export function buildMachiningContext(lang = "TR") {
      return lang === "EN" ? mach_en : mach_tr;
}


// -------------------------  Contact -------------------------

export function buildContactContext(lang = "TR") {
      return lang === "EN" ? contact_en : contact_tr;
}


